/**
 * Application Route Configuration
 * Defines all routes for the Forward Compute website
 */
import {html} from 'lit';
import type {RouteConfig} from '@lit-labs/router';

export const routes: RouteConfig[] = [
  {
    path: '/',
    render: () => html`<landing-page></landing-page>`,
  },
  {
    path: '/policies/privacy-policy',
    render: () => html`<privacy-policy-page></privacy-policy-page>`,
    enter: async () => {
      await import('../pages/privacy-policy-page.js');
      window.scrollTo(0, 0);
      return true;
    },
  },
  {
    path: '/policies/terms-of-service',
    render: () => html`<terms-of-service-page></terms-of-service-page>`,
    enter: async () => {
      await import('../pages/terms-of-service-page.js');
      window.scrollTo(0, 0);
      return true;
    },
  },
  {
    // Catch-all fallback - redirects to home
    path: '/*',
    render: () => html`<landing-page></landing-page>`,
  },
];
